module.exports = __webpack_public_path__ + "img/DE00179.9f77ddbd.svg";